import React from "react";
import "./Work.css";
// import myImage_1 from "../image/img_4.jpg";
// import myImage_2 from "../image/gal_6.jpg";
// import myImage_3 from "../image/img_7.jpg";
// import myImage_4 from "../image/gal_5.jpg";
// import myImage_5 from "../image/img_9.jpg";
// import myImage_6 from "../image/img_6.jpg";
import ImageWork from "./Image";

function Portfolio() {
  // useEffect(() => {
  //   const observer = new IntersectionObserver((entries) => {
  //     entries.forEach((entry) => {
  //       if (entry.isIntersecting) {
  //         entry.target.classList.add("show");
  //         entry.target.classList.remove("hidden");
  //       } else {
  //         entry.target.classList.remove("show");
  //         entry.target.classList.add("hidden");
  //       }
  //     });
  //   });

  //   const hiddenElements = document.querySelectorAll(".hidden");
  //   hiddenElements.forEach((el) => observer.observe(el));

  //   return () => {
  //     hiddenElements.forEach((el) => observer.unobserve(el));
  //   };
  // }, []);

  return (
    <div className="portfolio" id="work">
      <div className="text">
        <h1>Work</h1>
      </div>
      <ImageWork />
    </div>
  );
}

export default Portfolio;
